function getCalcValue(data) {
  if (data.length) {
    return `calc(${data.join(' + ')})`
  } else {
    return 0
  }
}

export function getFixedStyle(columns, fixed, index) {
  if (fixed === 'left') {
    let data = []
    for (let i = 0; i < index; i++) {
      if (!columns[i].fixed) continue
      data.push(columns[i].width)
    }
    return {
      position: 'sticky',
      left: getCalcValue(data)
    }
  } else if (fixed === 'right') {
    let data = []
    for (let i = index + 1; i < columns.length; i++) {
      if (!columns[i].fixed) continue
      data.push(columns[i].width)
    }
    return {
      position: 'sticky',
      right: getCalcValue(data)
    }
  } else {
    return {}
  }
}

export function getColumnWidth(width) {
  return width ? { width } : { flex: 1 }
}
